export default __webpack_public_path__ + "static/media/Blue-Android-1.ea7c80f8.png";